'use strict';

var bootstrap = angular.module('bootstrap');

bootstrap.run(balcaoRun)
bootstrap.config(centralConfig);

centralConfig.$inject = [
    '$stateProvider', '$urlRouterProvider', '$localStorageProvider', '$httpProvider',
    '$sessionStorageProvider', '$locationProvider', 'cfpLoadingBarProvider','ngSimditorProvider',
    '$animateProvider'
];

function centralConfig($stateProvider, $urlRouterProvider, $localStorageProvider, $httpProvider,
    $sessionStorageProvider, $locationProvider, cfpLoadingBarProvider, ngSimditorProvider, $animateProvider) {

    $animateProvider.classNameFilter(/animate/);

    ngSimditorProvider.setToolbar([
        'title', 'bold', 'italic', 'underline', 'alignments',
        'strikethrough', '|', 'ol', 'ul', 'blockquote', 
        'code', 'table', '|', 'link', 'hr', '|', 'indent', 
        'outdent', 'markdown']
    ).setLocale('pt-BR')

    $urlRouterProvider.otherwise("/login");

    $stateProvider

    .state('erro', {
        url: "/404",
        templateUrl: "404.html"
    })

    $localStorageProvider.setKeyPrefix('central-');
    $sessionStorageProvider.setKeyPrefix('central-');

    cfpLoadingBarProvider.includeSpinner = false;

    // Interceptadores de suporte
    $httpProvider.interceptors.push('SuporteIeItp');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });

    // Configurações de data
    moment.locale('pt-br');
}

balcaoRun.$inject = ['$rootScope', 'Usuario', '$state'];
function balcaoRun($rootScope, Usuario, $state) {

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

        $state.previous = { state: fromState, params: fromParams };

        if (!Usuario.verificarAutorizacao()) {
            if (Usuario.estadoMemorizado && (!_.has(fromState.data, 'redirecionarPara') || toState.name != fromState.data.redirecionarPara)) {
                Usuario.resetarAutorizacao();
            }

            if (_.has(toState.data, 'autorizacao') && _.has(toState.data, 'redirecionarPara')) {
                if (_.has(toState.data, 'memorizar') && toState.data.memorizar) {
                    Usuario.estadoMemorizado = toState.name;
                }

                $state.go(toState.data.redirecionarPara);
                toastr.error('Acesso não autorizado', 'Autorização');
            }
        }
    });

}


// WEBPACK FOOTER //
// ./src/core/config/central-app-config.js